import axios from '@/utils/axios';

// Types

export class PayloadCredentialsRequest {
	username!: string;
	password!: string;
}

export interface PayloadCredentialsResponse {
	token: string;
}

export class PayloadChangePasswordRequest {
	currentPassword!: string;
	newPassword!: string;
	newPasswordConfirm!: string;
}

export class ForgotPasswordRequest {
	username!: string;
}

export class ResetPasswordRequest {
	token!: string;
	newPassword!: string;
	newPasswordConfirm!: string;
}

export class PrepareActivateAccountRequest {
	username!: string;
	email!: string;
}

export class ActivateAccountRequest {
	token!: string;
	password!: string;
	passwordConfirm!: string;
}

// API

export default {
	async userLogin(payloadCredentials: PayloadCredentialsRequest): Promise<PayloadCredentialsResponse> {
		return (await axios().post('/auth/user/login/', payloadCredentials)).data;
	},
	async agentLogin(payloadCredentials: PayloadCredentialsRequest): Promise<PayloadCredentialsResponse> {
		return (await axios().post('/auth/agent/login/', payloadCredentials)).data;
	},
	async logout(): Promise<any> {
		return (await axios().post('/auth/logout/')).data;
	},
	async changePassword(payload: PayloadChangePasswordRequest) {
		return (await axios().patch('/auth/current/password/', payload)).data;
	},
	async changeAgentPassword(payload: PayloadChangePasswordRequest) {
		return (await axios().patch('/auth/current/agent/password/', payload)).data;
	},
	async current() {
		// return (await axios().get('/auth/current/')).data;
	},
	async forgotPassword(username: string) {
		return (await axios().post('/auth/forgot/', { username: username })).data;
	},
	async resetPassword(payload: ResetPasswordRequest) {
		return (await axios().post('/auth/reset/', payload)).data;
	},
	async prepareActivateAccount(payload: PrepareActivateAccountRequest) {
		return (await axios().post('/auth/prepare_activate/', payload)).data;
	},
	async activateAccount(payload: ActivateAccountRequest) {
		return (await axios().post('/auth/activate/', payload)).data;
	}
};
